import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { navigation } from '../navigation';
import { UserRepository } from 'src/app/repositories/user/UserRepository';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private _userRepository: UserRepository) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // const currentUser = this.authenticationService.currentUserValue;

        if (localStorage.getItem('userToken') != null) {
            return true;
        }

        this.router.navigate(['/login']);

        return false;
    }
}



